/* Analog Era — global behavior */
(function () {
  /* announcement rotation */
  var annc = document.querySelector('[data-annc]');
  if (annc) {
    var lines = JSON.parse(annc.getAttribute('data-annc') || '[]').filter(Boolean);
    var span = annc.querySelector('span'), i = 0;
    if (lines.length > 1) setInterval(function () {
      span.classList.add('out');
      setTimeout(function () { i = (i + 1) % lines.length; span.textContent = lines[i]; span.classList.remove('out'); }, 460);
    }, 5200);
  }

  /* scroll reveals */
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) { if (e.isIntersecting) e.target.classList.add('in'); });
    }, { threshold: 0.14 });
    document.querySelectorAll('.reveal').forEach(function (el) { io.observe(el); });
  } else {
    document.querySelectorAll('.reveal').forEach(function (el) { el.classList.add('in'); });
  }

  /* AJAX add-to-cart */
  document.querySelectorAll('form[data-ajax-cart]').forEach(function (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var btn = form.querySelector('[type=submit]');
      var orig = btn.textContent;
      btn.textContent = 'STAND BY…';
      fetch('/cart/add.js', { method: 'POST', body: new FormData(form) })
        .then(function (r) { if (!r.ok) throw r; return r.json(); })
        .then(function () { return fetch('/cart.js').then(function (r) { return r.json(); }); })
        .then(function (cart) {
          var c = document.querySelector('[data-cart-count]');
          if (c) c.textContent = cart.item_count;
          toast('ADDED — SIGNAL RECEIVED');
        })
        .catch(function () { toast('STATIC — TRY AGAIN'); })
        .finally(function () { btn.textContent = orig; });
    });
  });

  var toastT;
  function toast(msg) {
    var t = document.getElementById('aea-toast');
    if (!t) return;
    t.textContent = msg; t.classList.add('show');
    clearTimeout(toastT); toastT = setTimeout(function () { t.classList.remove('show'); }, 2400);
  }
})();
